import { render, staticRenderFns } from "./Watcher.vue?vue&type=template&id=5bafdc0c&"
import script from "./Watcher.vue?vue&type=script&lang=js&"
export * from "./Watcher.vue?vue&type=script&lang=js&"
import style0 from "./Watcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports